import React, { FC } from 'react';
import List from 'components/document-templates/components/List';

const Screen: FC = () => (
  <List
    entityName="templates"
    entityEndpoint="templates"
  />
);

export default Screen;
